const config = {
    local: {
        api: {
            baseUrl: 'http://localhost:4000',
            healthCheck: 'http://localhost:4000/api/health',
            port: 4000,
            cors: {
                origin: 'http://localhost:3000',
                methods: ['GET', 'POST', 'PUT', 'DELETE', 'OPTIONS'],
                allowedHeaders: ['Content-Type', 'Authorization']
            }
        },
        supabase: {
            url: process.env.REACT_APP_SUPABASE_URL,
            key: process.env.REACT_APP_SUPABASE_KEY
        },
        amazon: {
            baseUrl: 'https://sellingpartnerapi-eu.amazon.com',
            region: 'eu-west-1'
        },
        qonto: {
            baseUrl: 'https://thirdparty.qonto.com/v2',
            slug: process.env.REACT_APP_QONTO_SLUG_LOCAL,
            secretKey: process.env.REACT_APP_QONTO_SECRET_KEY_LOCAL
        }
    },
    vps: {
        api: {
            baseUrl: process.env.REACT_APP_VPS_API_URL,
            healthCheck: `${process.env.REACT_APP_VPS_API_URL}/api/health`,
            port: process.env.REACT_APP_PORT || 4000,
            cors: {
                origin: process.env.REACT_APP_CORS_ORIGIN || 'https://fbatrackify.com',
                methods: ['GET', 'POST', 'PUT', 'DELETE', 'OPTIONS'],
                allowedHeaders: ['Content-Type', 'Authorization']
            }
        },
        supabase: {
            url: process.env.REACT_APP_SUPABASE_URL,
            key: process.env.REACT_APP_SUPABASE_KEY
        },
        amazon: {
            baseUrl: 'https://sellingpartnerapi-eu.amazon.com',
            region: 'eu-west-1'
        },
        qonto: {
            baseUrl: 'https://thirdparty.qonto.com/v2',
            slug: process.env.REACT_APP_QONTO_SLUG,
            secretKey: process.env.REACT_APP_QONTO_SECRET_KEY
        }
    }
};

// Déterminer l'environnement actuel
const currentEnv = process.env.NODE_ENV === 'production' ? 'vps' : 'local';

export const getConfig = () => config[currentEnv];
export const isProduction = () => currentEnv === 'vps';

const environment = process.env.NODE_ENV === 'production' ? 'vps' : 'local';

export default {
    config: config[environment],
    environment
}; 